//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconRatingSadAlt(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.5 9.75C8.4665 9.75 9.25 8.9665 9.25 8C9.25 7.0335 8.4665 6.25 7.5 6.25C6.5335 6.25 5.75 7.0335 5.75 8C5.75 8.9665 6.5335 9.75 7.5 9.75Z" fill="currentColor" /><path d="M16.5 9.75C17.4665 9.75 18.25 8.9665 18.25 8C18.25 7.0335 17.4665 6.25 16.5 6.25C15.5335 6.25 14.75 7.0335 14.75 8C14.75 8.9665 15.5335 9.75 16.5 9.75Z" fill="currentColor" /><path d="M12.0002 13C8.93016 13 6.07016 14.39 4.16016 16.81L5.73016 18.05C7.26016 16.11 9.54016 15 12.0002 15C14.4602 15 16.7402 16.11 18.2802 18.05L19.8502 16.81C17.9302 14.39 15.0702 13 12.0002 13Z" fill="currentColor" /></svg>;
}
export default IconRatingSadAlt;